import { render, staticRenderFns } from "./RecursosHumanosUsuarioPage.vue?vue&type=template&id=79a6677a&scoped=true"
import script from "./RecursosHumanosUsuarioPage.vue?vue&type=script&lang=js"
export * from "./RecursosHumanosUsuarioPage.vue?vue&type=script&lang=js"
import style0 from "./RecursosHumanosUsuarioPage.vue?vue&type=style&index=0&id=79a6677a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6677a",
  null
  
)

export default component.exports